export default __webpack_public_path__ + "static/media/logo-apple.93bc7ddf.svg";